import { executeRequest, Request } from '@jfs/network'
import { AgentInfo } from '../../data/models/Agent'
import { VoucherDetails } from '../../data/models/Refund/RefundCode'
import { RootStore } from '../../data/store'

import { generateRandomNumber, getNetworkResponseError, getUTCTimeStamp, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { apiConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  if (isStatusOK(data) && data?.data?.responseCode === '00' && data?.data?.responseData) {
    return data?.data?.responseData
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

export const redeemRefund = (tokens: any, apiRequest: any) => {
  const config = apiConfig(tokens)
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers.userIDToken = RootStore?.bcAppInfo?.userIdentifier
  const request: Request<{}> = {
    //apiPath:'http://10.162.6.163:9012/jpb/v1/ats/voucher/redeem',
    apiPath: APIEndPoints.redeemVoucher,
    method: 'POST',
    config,
    body: apiRequest,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}

export const getRedeemRequest = (agent: typeof AgentInfo.properties, voucherInfo: typeof VoucherDetails.properties) => {
  const randomNum = generateRandomNumber(16)
  return {
    transaction: {
      idempotentKey: randomNum,
      originalId: voucherInfo.originalTranId, //htag todo originalTranId
      currency: 356,
      invoice: randomNum,
      method: {
        type: 429,
        subType: 612,
      },
      mode: 2, //need to verify
      metadata: {
        agent: {
          id: agent.parentOnboardingId,
          agentUser: {
            id: agent.agentUserLoginId,
          },
          subId: null,
          address: {
            stateCode: agent.agentUserDealerState,
            pinCode: agent.agentUserDealerPinCode,
          },
        },
      },
      captureMethod: 1,
      livemode: true,
      application: RootStore?.agent?.session?.CHANNEL_ID, ///CHANNEL_ID
      initiatingEntityTimestamp: getUTCTimeStamp(),
      initiatingEntity: {
        entityId: RootStore?.agent?.session?.CHANNEL_ID,
        callbackUrl: null,
      },
    },
    voucherDetails: {
      id: voucherInfo.voucherId,
      code: voucherInfo.voucherCode,
    },
    amount: {
      netAmount: voucherInfo.voucherAmount, //VOUCHERAMOUNT
      grossAmount: voucherInfo.voucherAmount,
      charges: [
        {
          value: '',
          cgst: '',
          igst: '',
          sgst: '',
          ugst: '',
          serviceCharge: '',
          tds: '',
          tcs: '',
          type: '',
        },
      ],
    },
    payee: {
      userId: voucherInfo.remittanceDetails?.remitterId,
      mobile: {
        number: voucherInfo.remittanceDetails?.mobileNumber?.number,
        countryCode: voucherInfo.remittanceDetails?.mobileNumber?.countryCode,
      },
      type: 13, // need to verify
    },
    secure: {
      deviceInfo: {
        peripheral: 'biometric device encrypted code',
        source: {
          type: 'MOB',
          id: RootStore?.agent?.deviceInfo?.id,
          ip: RootStore?.agent?.deviceInfo?.ip,
          osType: 'ANDROID',
          osVer: RootStore?.agent?.deviceInfo?.osVer,
          model: RootStore?.agent?.deviceInfo?.model,
        },
        location: {
          latitude: RootStore?.agent?.deviceInfo?.latitude,
          longitude: RootStore?.agent?.deviceInfo?.longitude,
        },
      },
    },
  }
}
